import type {Distribution, _Distribution} from './distribution';

/**
 * Generated from com.dataiku.dip.eda.compute.distributions.Pareto
 */
export interface Pareto extends _Distribution {
    // PolyJson type
    type: 'pareto';
}

export namespace Pareto {
    export const type = 'pareto';
}

/** @deprecated Use Distribution.isPareto() */ export function isPareto(toTest: Distribution): toTest is Pareto { return Pareto.type === toTest['type']; }

export namespace Pareto {
    /**
     * Generated from com.dataiku.dip.eda.compute.distributions.Pareto$FittedPareto
     */
    export interface FittedPareto extends Distribution._FittedDistribution {
        scale: number;
        shape: number;

        // PolyJson type
        type: 'pareto';
    }

    export namespace FittedPareto {
        export const type = 'pareto';
    }

    /** @deprecated Use Distribution.FittedDistribution.isFittedPareto() */ export function isFittedPareto(toTest: Distribution.FittedDistribution): toTest is FittedPareto { return FittedPareto.type === toTest['type']; }
}